import { useCookies } from '@packages/utilities';

import { newInfiniteScrolling } from '../activeFeatureFlags';
import { hasFeatureFlag } from '../utils/featureFlags/hasFeatureFlag';

export const getDefaultPageSize = (cookies: Record<string, string>) => {
  const hasNewInfiniteScrolling = hasFeatureFlag(newInfiniteScrolling, cookies);

  // actual visible card count is 36 and 74 when including the search buddy teaser cards
  return hasNewInfiniteScrolling ? 35 : 72;
};

export const useDefaultPageSize = () => {
  const { getCookies } = useCookies();

  return getDefaultPageSize(getCookies());
};
